import { useContext } from 'react';

import { ProctoringEKycVerificationContext } from './proctoring-ekyc-verification-provider';

function useProctoringEKycVerification() {
  const context = useContext(ProctoringEKycVerificationContext);

  if (!context) {
    throw new Error(
      'useProctoringEKycVerification must be used within a ProctoringEKycVerificationProvider',
    );
  }

  return context;
}

export { useProctoringEKycVerification };
